import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/step2",
    name: "Step2",
    component: () =>
      import(/* webpackChunkName: "Step2" */ "../views/Step2.vue"),
  },
  {
    path: "/step3",
    name: "Step3",
    component: () =>
      import(/* webpackChunkName: "Step3" */ "../views/Step3.vue"),
  },
  {
    path: "/person/:retView",
    name: "Person",
    component: () =>
      import(/* webpackChunkName: "Person" */ "../views/Person.vue"),
  },
  {
    path: "/pinpay",
    name: "PinPay",
    component: () =>
      import(/* webpackChunkName: "PinPay" */ "../views/Pay.vue"),
  },
  {
    path: "/PaySuccess/:charge_token",
    name: "PaySuccess",
    component: () =>
      import(/* webpackChunkName: "PaySuccess" */ "../views/PaySuccess.vue"),
    meta: {
      //hideNavigation: true,
    }
  },
  {
    path: "/tickets",
    name: "Tickets",
    component: () =>
      import(/* webpackChunkName: "Tickets" */ "../views/Tickets.vue"),
  },
  {
    path: "/viewpeople",
    name: "People",
    component: () =>
      import(/* webpackChunkName: "People" */ "../views/ViewPeople.vue"),
  },
  {
    path: "/email",
    name: "Email",
    component: () =>
      import(/* webpackChunkName: "Email" */ "../views/Email.vue"),
  },
  {
    path: "/:mode?",
    name: "Start",
    component: () =>
      import(/* webpackChunkName: "Start" */ "../views/Step1.vue"),
    props: true,
  },
];

const router = new VueRouter({
  mode: "history",
  // eslint-disable-next-line no-undef
  base: process.env.BASE_URL,
  routes,
});

export default router;
